import { render, staticRenderFns } from "./divisoes.vue?vue&type=template&id=e5fd54a4&"
import script from "./divisoes.vue?vue&type=script&lang=js&"
export * from "./divisoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports